document.addEventListener("DOMContentLoaded", function () {
  $(".article-new-wrapper .article-right-part .side-banner").click(function () {
    const creative_name = $(this).attr("href");
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "click_banner",
      event_parameters: {
        creative_name: creative_name,
        creative_slot: "banner_1",
        position: "1",
        button_name: "Side Banner",
      },
    });
  });

  window.addEventListener("klaviyoForms", async function (e) {
    if (e.detail.type === "submit" && e.detail.formId === "S9XHtB") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "subscribe",
        event_parameters: {
          module: "Blog Side Banner Subscription",
          status: "success",
          email: e.detail.metaData.$email,
          content_name: '',
        },
      });
    }
  });

  function capitalizeWords(str) {
    return str
      .split(' ') // 按空格分割字符串
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // 转换每个单词
      .join(' '); // 重新组合成字符串
  }

  function product_page_ga4_deal_with_discount(product_item, buttom_name, event_name, discount = 0) {
    let $v_item_name = '';
    let $v_item_variant = '';
    let $v_item_category = '';
    let $v_item_category2 = 'Standard';
    if (product_handle_map.has(product_item[0])) {
      $v_item_name = product_handle_valueMap[product_item[0]][0];
      $v_item_variant = product_handle_valueMap[product_item[0]][1];
      $v_item_category = product_handle_valueMap[product_item[0]][2];
      $v_item_category2 = product_handle_valueMap[product_item[0]][3];
    }

    let event_parameters_before = {
      item_list_id: capitalizeWords(product_item[4]),
      item_list_name: capitalizeWords(product_item[4]),
      currency: 'EUR',
      value: Number(product_item[9].split('€').join('').split(',').join('.')),
      items: [
        {
          item_id: product_item[0],
          item_name: $v_item_name,
          index: product_item[2],
          item_list_id: capitalizeWords(product_item[4]),
          item_list_name: capitalizeWords(product_item[4]),
          item_category: $v_item_category,
          item_category2: $v_item_category2,
          item_category3: product_item[6].replace('Default Title', 'none'),
          item_variant: $v_item_variant,
          item_brand: 'SHOKZ',
          price: Number(product_item[9].split('€').join('').split(',').join('.')),
          quantity: Number(product_item[10]),
          currency: 'EUR',
          discount: discount,
        },
      ],
    };

    if (buttom_name) {
      event_parameters_before.button_name = buttom_name;
    }

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: event_name,
      event_parameters: event_parameters_before,
    });
  }

  function trackBuyCardClick($trigger, source, event_name) {
    const $buyCard = $trigger.closest('.apc-content');
    if (!$buyCard.length) return;

    // 产品数据
    let productData =
      $trigger.data('product-data');

    if (!productData) return;

    const product_item = productData.split('::');

    // 当前价格（不包含对比价）
    const priceText = $buyCard
      .find('.price-value')
      .text()
      .replace(/[^\d.]/g, '');

    // 对比价
    const compareText = $buyCard
      .find('.tag_sale-compare-price')
      .text()
      .replace(/[^\d.]/g, '');

    const price = parseFloat(priceText) || 0;
    const compare_at_price = parseFloat(compareText) || 0;

    const discount = compare_at_price > price ? +(compare_at_price - price).toFixed(2) : 0;

    // GA4
    product_page_ga4_deal_with_discount(product_item, source, event_name, discount);
  }

  function trackProductLinkClick($trigger, source, event_name) {
    // 产品数据
    let productData =
    $trigger.data('product-data');

    if (!productData) return;

    const product_item = productData.split('::');

    // 当前价格（不包含对比价）
    const priceText = $trigger
      .find('.price-value')
      .text()
      .replace(/[^\d.]/g, '');

    // 对比价
    const compareText = $trigger
      .find('.tag_sale-compare-price')
      .text()
      .replace(/[^\d.]/g, '');

    const price = parseFloat(priceText) || 0;
    const compare_at_price = parseFloat(compareText) || 0;

    const discount = compare_at_price > price ? +(compare_at_price - price).toFixed(2) : 0;

    // GA4
    product_page_ga4_deal_with_discount(product_item, source, event_name, discount);
  }


  $('.article-product-card .apc-content .learn-more').click(function () {
    trackBuyCardClick($(this), 'Learn More', 'select_item');
  });

  $('.tt-post-content a.product-link').click(function () {
    trackProductLinkClick($(this), 'Product Link', 'select_item');
  });

});
